import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import menujson from '../../Json/menu.json';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import ContinueCard from '../../Components/Card/ContinueCard';
import StudentTabs from '../../Components/Tabs/StudentTabs';

const pathToParentMenu = ['root'];

const StudentDashboard = (props) => {
    const navigate = useNavigate();
    const [menuJson, setMenuJson] = useState(menujson);

    const classes = useStyles();
    return (
        <Grid container>
            {/* <GenerateMenu menuJson={menuJson} goToSubmenu={goToSubmenu}></GenerateMenu>
            {pathToParentMenu.length > 1 &&
                <Button variant="contained" color='secondary' onClick={backMenu}>Back</Button>
            } */}

            <Grid item xs={12}>
                <Grid sx={{ position: 'relative' }}>
                    <Grid container className={classes.scrollBarHeight} sx={{
                        flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', background: 'linear-gradient(to bottom, rgba(232,237,255,1) 0%,rgba(243,245,255,1) 44%,rgba(245,247,255,0.92) 54%,rgba(255,255,255,0.53) 100%);', overflow: 'auto', width: '95%', marginLeft: 4, borderTopLeftRadius: 15, borderTopRightRadius: 15,
                    }}>
                        <StudentTabs />

                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
const useStyles = makeStyles({
    scrollBar: {
        '&::-webkit-scrollbar': {
            width: '0.6em'
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            borderRadius: 5
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5
        }
    },
    scrollBarHeight: {
        "&::-webkit-scrollbar": {
            height: '0.6em'
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            borderRadius: 5
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5
        }
    },
})
export default StudentDashboard;